<template>
    <section class="full" id="planoTemplate">
        <loader :loading="loading || saving"></loader>
        <section class="flexContainer center fd-c full">
            <div class="ariane center">
                <ul class="listStep flexContainer uppercase">
                    <li class="steps pointer" @click="step(1);" :class="{ active: rollIndexAriane === 1 }">
                        <span>{{ $t("templatePlano.type") }}</span>
                    </li>
                    <li class="steps pointer" @click="step(2);" :class="{ active: rollIndexAriane === 2 }">
                        <span>{{ $t("templatePlano.size") }}</span>
                    </li>
                    <li class="steps pointer" @click="step(3);" :class="{ active: rollIndexAriane === 3 }">
                        <span>{{ $t("templatePlano.template") }}</span>
                    </li>
                    <li class="steps pointer" @click="step(4);" :class="{ active: rollIndexAriane === 4 }">
                        <span>{{ $t("templatePlano.summary") }}</span>
                    </li>
                </ul>
            </div>
            <section id="wrapContent" class="center">
                <h2 class="ff-medium txtCenter uppercase" v-if="rollIndexAriane === 1">{{ $t("templatePlano.createTitle") }}</h2>
                <h3 v-if="rollIndexAriane === 1">{{ $t("templatePlano.planoName") }}</h3>
                <input
                    type="text"
                    v-model="planoName"
                    class="templateInput block"
                    id="planoName"
                    v-if="rollIndexAriane === 1"
                    :placeholder="$t('templatePlano.title')"
                />
                <div v-if="rollIndexAriane === 1">
                    <label class="ff-medium block">{{ $t("templatePlano.zone") }} :</label>
                    <select v-model="selectedZone" class="uppercase selectBrand">
                        <option class="capitalize" :value="null">{{ $t("templatePlano.zoneTitle") }}</option>
                        <option class="capitalize" v-for="zone in selectedBrand.zones" :key="zone.id" :value="zone">{{ zone.name }}</option>
                    </select>
                </div>
                <hr v-if="rollIndexAriane === 1" class="separator" />

                <div v-if="rollIndexAriane === 1 && selectedZone != null">
                    <label class="ff-medium block">{{ $t("templatePlano.standDesign") }} :</label>
                    <select v-model="selectedStandDesign" class="uppercase selectBrand">
                        <option class="capitalize" :value="null">{{ $t("templatePlano.standDesign") }}</option>
                        <option class="capitalize" v-for="standDesign in standDesignList" :key="standDesign.id" :value="standDesign">
                            {{ standDesign.name }}
                        </option>
                    </select>
                </div>

                <h3 class="ff-medium txtCenter" v-if="selectedZone && selectedStandDesign && rollIndexAriane === 1">
                    {{ $t("templatePlano.campaign") }}
                </h3>
                <div class="center selectZones">
                    <div class="campaignList flexContainer fw-w jc-sb" v-if="selectedZone && selectedStandDesign && rollIndexAriane === 1">
                        <div class="panel panel-default" v-for="campaign in campaignsList" :key="campaign.name">
                            <div class="panel-body compaignName">
                                <div class="checkbox">
                                    <div
                                        class="rel choice"
                                        style="display:table"
                                        @click="campaignChoosen(campaign);"
                                        :class="{ active: selectedCampaign && selectedCampaign.id == campaign.id }"
                                    >
                                        <input class="full radio abs pointer" type="radio" :value="campaign" v-model="selectedCampaign" />
                                        <p class="rel capitalize txtCenter">{{ campaign.name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h2 class="ff-medium txtCenter uppercase" v-if="rollIndexAriane === 2">{{ $t("templatePlano.sizeTitle") }}</h2>
                    <template v-if="rollIndexAriane === 2">
                        <template v-if="templateSize && Array.isArray(templateSize) && templateSize.length > 0">
                            <h3>{{ $t("templatePlano.heightTitle") }}</h3>
                            <div class="flexContainer center fw-w jc-sb sizes" v-if="rollIndexAriane === 2">
                                <div
                                    class="panel panel-default"
                                    v-for="(c, index) in templateSize"
                                    :key="c.heightExternal"
                                    v-if="selectedCampaign !== ''"
                                >
                                    <div class="panel-body">
                                        <div class="checkbox">
                                            <div class="rel choice" @click="heightChoosed(index);" :class="{ active: rollIndexHeight === index }">
                                                <img src="../../assets/vertical.png" class="vertical abs txtCenter" alt height="20" width="20" />
                                                <input
                                                    :id="'item' + index"
                                                    class="full radio abs pointer"
                                                    type="radio"
                                                    :name="c.heightExternal + 'h'"
                                                    :value="c.heightExternal"
                                                    v-model="selectedHeight"
                                                    @change="selectHeight"
                                                />
                                                <p class="rel number txtCenter">{{ c.heightExternal }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="separator" v-if="selectedHeight !== '' && rollIndexAriane === 2" />
                            <h3 v-if="selectedHeight !== '' && rollIndexAriane === 2">{{ $t("templatePlano.widthTitle") }}</h3>
                            <div class="flexContainer center">
                                <div
                                    class="panel panel-default sizes"
                                    v-for="(c, index) in width"
                                    :key="c.widthExternal"
                                    v-if="selectedHeight !== '' && rollIndexAriane === 2"
                                >
                                    <div class="panel-body">
                                        <div class="checkbox">
                                            <div class="rel choice" @click="widthChoosed(index);" :class="{ active: rollIndexWidth === index }">
                                                <img src="../../assets/horizontal.png" class="horizontal abs txtCenter" alt height="20" width="20" />
                                                <input
                                                    :id="'item' + index"
                                                    class="full radio abs pointer"
                                                    type="radio"
                                                    :name="c.widthExternal + 'w'"
                                                    :value="c.widthExternal"
                                                    v-model="selectedWidth"
                                                />
                                                <p class="rel txtCenter">{{ c.widthExternal }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            {{ $t("templatePlano.NoSizesAvailable") }}
                        </template>
                    </template>
                    <h2 class="ff-medium txtCenter uppercase" v-if="rollIndexAriane === 3">{{ $t("templatePlano.templateTitle") }}</h2>
                    <div class="flexContainer jc-sb" v-if="selectedWidth !== '' && rollIndexAriane === 3">
                        <div class="flexContainer jc-fs fw-w full">
                            <div class="checkbox rel size1of4 pointer txtCenter planoChoice" v-for="(img, index) in templates" :key="img.name">
                                <div :class="{ active: selectedPlano === index }">
                                    <input
                                        type="radio"
                                        class="abs pointer full imgRadio"
                                        :value="img"
                                        v-model="selectedTemplate"
                                        @change="selectPlano(index);"
                                    />
                                    <SystemTypeIcon :type="img.systemType.id"></SystemTypeIcon>
                                    <label :for="img.name" class="block txtCenter">{{ img.name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="summary" v-if="summ === true && rollIndexAriane === 4">
                        <label class="ff-medium">{{ $t("templatePlano.planoName") }}</label>
                        <p>{{ template.name }}</p>

                        <label class="ff-medium">{{ $t("templatePlano.planoTemp") }}</label>
                        <p><img src="../../../static/assets/plano.png" class="txtCenter" alt /></p>

                        <label class="ff-medium">{{ $t("templatePlano.zone") }}</label>
                        <p class="capitalize">{{ selectedZone.name }}</p>

                        <label class="ff-medium">{{ $t("templatePlano.standDesign") }}</label>
                        <p class="capitalize">{{ selectedStandDesign.name }}</p>

                        <label class="ff-medium">{{ $t("templatePlano.campaignS") }}</label>
                        <p>{{ selectedCampaign.name }}</p>

                        <label class="ff-medium">{{ $t("templatePlano.planoSize") }}</label>
                        <p>{{ selectedWidth }} X {{ selectedHeight }}</p>
                    </div>
                    <div class="center buttons">
                        <button
                            @click="ariane($event);"
                            id="btnNext"
                            class="fright btn btn-dark pointer"
                            :class="{ disabled: disabled }"
                            v-if="rollIndexAriane < 4"
                        >
                            {{ $t("templatePlano.nextStep") }}
                        </button>
                        <button @click="arianePrev" class="fleft btn pointer" v-if="rollIndexAriane > 1">
                            {{ $t("templatePlano.previousStep") }}
                        </button>
                        <button class="fright btn btn-dark pointer" @click="save" v-if="summ === true && rollIndexAriane === 4">
                            {{ $t("templatePlano.send") }}
                        </button>
                    </div>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
import { setUser } from "../../directives/setUser.js";
import httpService from "../service";
import { mapGetters, mapActions } from "vuex";
import "whatwg-fetch";
import loader from "../loader/loader";
import SystemTypeIcon from "@/components/planoList/SystemTypeIcon";
import { isValidNameLength } from "@/utils/string";
import cacheService from "@/services/cache";
import { TrySaveMixin } from "@/mixins/TryLoadMixin";

export default {
    components: {
        loader,
        SystemTypeIcon
    },
    mixins: [TrySaveMixin],
    data: () => ({
        rollIndexAriane: 1,
        rollIndexCampaign: null,
        rollIndexHeight: null,
        rollIndexWidth: null,
        planoName: null,
        user: "",
        string: "",
        brands: [],
        campaign: [],
        standDesignList: [],
        campaignsList: [],
        selectedBrand: { id: null },
        selectedStandDesign: null,
        selectedZone: null,
        selectedCampaign: null,
        height: [],
        selectedHeight: "",
        selectedWidth: "",
        width: [],
        templateSummary: {},
        summ: false,
        type: false,
        size: false,
        template: {},
        summary: false,
        zone: [],
        templates: [],
        selectedTemplate: {},
        templateSize: {},
        selectedPlano: null,
        planos: [],
        disable: false,
        zoneId: cacheService.getCurrentZoneId(),
        loading: false
    }),
    watch: {
        async "selectedStandDesign.id"() {
            if (this.selectedStandDesign) await this.getCampaigns();
            this.initializeSizeValues();
            this.selectedCampaign = null;
        }
    },
    methods: {
        ...mapActions("plano/data", {
            setShowRestore: "setShowRestore"
        }),
        ...mapActions("currentUser", {
            setCurrentZoneId: "setCurrentZoneId",
            setCurrentCampaignId: "setCurrentCampaignId",
            setCurrentStandDesignId: "setCurrentStandDesignId"
        }),
        async save() {
            try {
                this.loading = true;
                const isNext = this.selectedTemplate.systemType.id !== 1;
                const planoId = await this.trySave(() => httpService.post("/plano/new", JSON.stringify(this.template)));
                await this.setCurrentCampaignId(this.template.campaign.id);
                this.setCurrentZoneId(this.template.zone.id);
                await this.setCurrentStandDesignId(this.selectedStandDesign.id);
                this.$router.push(`/plano${isNext ? "next" : ""}/` + planoId);
                cacheService.set("planoLocked", false);
                this.setShowRestore(false);
                cacheService.set("showRestore", false);
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        },
        campaignChoosen(campaign) {
            this.selectedCampaign = campaign;
        },
        heightChoosed(index) {
            this.rollIndexHeight = index;
        },
        widthChoosed(index) {
            this.rollIndexWidth = index;
        },
        selectHeight() {
            this.selectedWidth = undefined;
            this.rollIndexWidth = undefined;
            for (let i in this.templateSize) {
                if (this.templateSize[i].heightExternal === this.selectedHeight) {
                    this.width = this.templateSize[i].widthExternal;
                }
            }
        },
        initializeSizeValues() {
            this.rollIndexHeight = undefined;
            this.rollIndexWidth = undefined;
            this.selectedHeight = undefined;
            this.selectedWidth = undefined;
            this.width = [];
            this.height = [];
        },
        arianePrev() {
            this.rollIndexAriane = this.rollIndexAriane - 1;
        },

        ariane(event) {
            for (let i in this.planos) {
                if (this.planoName === this.planos[i].name) {
                    this.disable = true;
                    this.dialogError("Désolé, ce nom existe déjà dans la base");
                    return false;
                }
            }
            if (event.target.classList.contains("disabled")) {
                return false;
            } else {
                this.disable = true;
                this.rollIndexAriane = this.rollIndexAriane + 1;
                if (this.rollIndexAriane === 4) {
                    this.summ = true;
                    this.template = {
                        name: this.planoName,
                        brand: { id: this.selectedBrand.id },
                        zone: { id: this.selectedZone.id },
                        campaign: { id: this.selectedCampaign.id },
                        height: this.selectedHeight,
                        width: this.selectedWidth,
                        template: { id: this.selectedTemplate.id, DISP_discr: this.selectedTemplate.discr }
                    };
                }
                if (this.rollIndexAriane === 3) {
                    httpService
                        .get(
                            `/displayers?flags=1,2&height=${this.selectedHeight}&width=${this.selectedWidth}&stand_design=${
                                this.selectedStandDesign.id
                            }&zone=${this.selectedZone.id}`
                        )
                        .then(response => (this.templates = response.data));
                }
                if (this.rollIndexAriane === 2) {
                    httpService
                        .get(`/displayers/size?stand_design=${this.selectedStandDesign.id}&zone_id=${this.selectedZone.id}`)
                        .then(response => (this.templateSize = response));
                }
            }

            return true;
        },
        selectPlano(index) {
            this.selectedPlano = index;
        },
        step(n) {
            switch (n) {
                case 1:
                    this.rollIndexAriane = 1;
                    break;
                case 2:
                    for (let i in this.planos) {
                        if (
                            this.planoName &&
                            this.selectedBrand != null &&
                            this.selectedZone != null &&
                            this.selectedCampaign != null &&
                            this.planoName !== this.planos[i].name
                        ) {
                            this.rollIndexAriane = 2;
                        } else if (this.planoName === this.planos[i].name) {
                            return false;
                        } else {
                            return false;
                        }
                    }
                    break;
                case 3:
                    if (this.selectedWidth !== "" && this.selectedHeight !== "") {
                        this.rollIndexAriane = 3;
                    } else {
                        return;
                    }
                    break;
                case 4:
                    if (this.selectedPlano !== null) {
                        this.rollIndexAriane = 4;
                    } else {
                        return;
                    }
                    break;
                default:
                    this.rollIndexAriane = 1;
            }
        },
        updateVueResults(datas) {
            this.planos = datas;
        },
        async getStandDesigns() {
            try {
                const res = await httpService.get("/admin/standDesigns/list?type=stand");
                this.standDesignList = res.data;
                if (this.standDesignList.length == 1) {
                    this.selectedStandDesign = this.standDesignList[0];
                }
            } catch (e) {
                this.dialogError(e);
            }
        },
        async getCampaigns() {
            try {
                const res = await httpService.get("/admin/campaigns/list?limit=100");
                this.campaignsList = res.data;
                return res;
            } catch (e) {
                this.dialogError(e);
            }
        }
    },
    computed: {
        planoNameIsCorrect() {
            return isValidNameLength(this.planoName);
        },
        disabled() {
            if (this.loading) return true;
            switch (this.rollIndexAriane) {
                case 1:
                    return (
                        !this.planoNameIsCorrect ||
                        this.planoName.trim().length === 0 ||
                        !this.selectedZone ||
                        !this.selectedCampaign ||
                        !this.selectedStandDesign ||
                        this.planos.some(plano => this.planoName === plano.name)
                    );
                case 2:
                    return !this.selectedWidth || !this.selectedHeight;

                case 3:
                    return this.selectedPlano === null;
                default:
                    return false;
            }
        },
        ...mapGetters({
            getResults: "planos/search/getResults"
        }),
        ...mapGetters("currentUser/", ["currentUser"])
    },
    directives: {
        setUser
    },
    created() {
        this.rollIndexAriane = 1;
        this.selectedBrand = this.currentUser.user.brands.find(brand => brand.id == this.currentUser.brandId);
        this.getStandDesigns();
        this.height = this.selectedBrand.size;
        this.$store.dispatch("planos/search/getResults").then(() => {
            this.updateVueResults(this.getResults());
        });
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";
#planoTemplate {
    @extend %primary-text;
    font-size: 1.4rem;
    .selectBrand {
        width: 100%;
    }
    .ariane {
        .listStep {
            padding-left: 0px;
            padding-top: 35px;
            margin: 0;
            border-bottom: 1px solid #ccc;
            .steps {
                padding: 15px 0px;
                list-style: none;
                font-size: 1.8rem;
                span {
                    padding: 0 25px;
                    border-right: 1px solid #dedede;
                }
                &.active {
                    font-weight: 500;
                    border-bottom: 2px solid #343434;
                    @extend %second-border-color;
                }
                &:last-child {
                    span {
                        border: none;
                    }
                }
            }
        }
    }
    #wrapContent {
        h2 {
            padding: 20px 0;
        }
        #planoName {
            width: 300px;
        }
        label {
            margin: 20px 0;
        }
        select {
            border: none;
            @extend %second-background;
            @extend %second-text;
            font-size: inherit;
            height: 30px;
        }
        input {
            height: 30px;
        }
        .separator {
            border: 1px solid #dedede;
            border-top: none;
            margin: 30px 0;
        }
        .checkbox {
            padding-top: 10px;
        }
        .planoChoice {
            padding: 0 10px;
            margin-bottom: 15px;
            div {
                padding: 15px;
                &.active {
                    background: #ccc;
                }
                label {
                    margin-top: 10px;
                    margin-bottom: 0px;
                }
                .imgRadio {
                    height: 100%;
                    opacity: 0;
                    top: 0;
                    left: 0;
                }
            }
        }
        .radio {
            opacity: 0;
            z-index: 5;
            height: 100%;
        }
        .choice {
            border-radius: 3px;
            width: 125px;
            height: 60px;
            background-color: #eee;
            @extend %second-background;
            @extend %second-text;
            @extend %second-border-color;
            .vertical {
                top: 20px;
                left: 30px;
            }
            .horizontal {
                left: 22px;
                top: 18px;
            }
            &:hover {
                background-color: #ccc;
                color: #343434;
            }
            p {
                margin: auto;
                height: 60px;
                top: 22px;
                z-index: 2;
            }
            &.active {
                color: white;
                font-weight: 500;
                border: 1px solid #41b4e8;
                background-color: #41b4e8;
            }
        }
        #summary {
            padding-top: 30px;
        }
        .sizes {
            width: 560px;
        }
        .templateInput {
            border: none;
            border-bottom: 2px solid #000;
            @extend %second-background;
            @extend %second-text;
            @extend %second-border-color;
        }
        .templatePlanoTitle {
            padding-top: 40px;
        }
        .templateTitles {
            padding-top: 0px;
        }
        .interligne {
            line-height: 11px;
        }
        .selectZones {
            width: 560px;
        }
        .buttons {
            button {
                background-color: #111;
                color: #fff;
            }
            margin-top: 30px;
            .disabled {
                background: #ccc;
                border: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// templatePlano.vue?74c0ecc8